import type { ISellItem } from '../SellView/ISellView'

export interface IList {
  id: string
  isChecked: boolean
  name: string
  numberOfitems: number
  lastOpened: string
  lastChanged: string
  createdDate: string
  publicationDate?: string
  startDate?: string
  publicationResult?: string
  items: string[]
  columnOrder: string[]
  message?: any
  hasBeenExported: boolean
  publishing: boolean
  publishStarted?: string
}

export interface IPublishViewModel {
  listId: string
  selectedItems: string[]
  uploadInterval: number
  uploadDateTime: string
  sellItems?: ISellItem[]
}

export interface IImportViewModel {
  listId?: string
  items: any[]
}

export enum PublishExceptionCode {
  Unknown = 'Unknown',
  BankIdVerificationNeeded = 'BankIdVerificationNeeded',
  UserCancelled = 'UserCancelled',
  PublishLocked = 'PublishLocked',
}

export interface IPublishException {
  errorCode: PublishExceptionCode
  listId: string
  selectedItems?: string[]
  uploadInterval: number
  uploadDateTime: string
  personalNumber?: string
  message?: string
  sellItems?: ISellItem[]
}

/**
 * This is the view model used in the publishList response from prolister-backend.
 */
export type ProListViewModel = {
  id: string
  isChecked: boolean
  userId: string
  // ListType ListType { get; set; }
  name: string
  numberOfAdvertisements: number
  lastOpened: string
  lastChanged: string
  createdDate: string
  publicationDate: string
  startDate: string
  publicationResult: string
  hasBeenExported: boolean
  publishing: boolean
  publishStarted: string
  items: ItemViewModel[]
}

/**
 * This is the view model used in the publishList response from prolister-backend.
 */
type ItemViewModel = {
  id: string
  listId: string
  isChecked: boolean
  imageRotations: string[]
  imageUrls: string[]
  campaignCode: string
  campaignCodeValid: boolean
  header: string
  description: string
  category: unknown // TODO: Define this type when needed
  startingBid: number
  buyNowPrice: number
  reservationPrice: number
  shippingCostFirst: number
  isHighlighted: boolean
  reference: string
  latestUploadDate: string
  condition: string
  uploadOrder: number
  latestObjectId: string
  advertisementLengthInDays: number
  rankUp: boolean
  restarts: number
  acceptedBidders: number
  exposure: string
  publishResult: string
  shippingAlternative: unknown // TODO: Define this type when needed
  paymentOptions: unknown // TODO: Define this type when needed
  itemType: string
  attributes: unknown[] // TODO: Define this type when needed
  chosenEndTimeHour: number
  chosenEndTimeMinute: number
  hasChosenEndTime: boolean
  shippingCondition: string
  quantity: number
  vat: number
}
